import authService from '../../services/auth.js';

export class VerificationCodeInput {
    constructor(email, onVerified) {
        this.email = email;
        this.onVerified = onVerified;
        this.timer = null;
        this.timeRemaining = 30; // Start with 30 seconds
        this.isInitialCode = true;
        
        this.container = document.createElement('div');
        this.container.className = 'verification-code-container';
        this.render();
        this.setupEventListeners();
    }

    render() {
        this.container.innerHTML = `
            <div class="mb-4">
                <p class="mt-2 text-sm text-gray-600">Введите код подтверждения, отправленный на ваш email</p>
                <label class="block text-gray-700 text-sm font-bold mb-2" for="verification-code">
                    Код проверки
                </label>
                <input type="text" 
                    id="verification-code" 
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Введите проверочный код">
                <p id="error-message" class="text-red-500 text-xs italic mt-1 hidden"></p>
            </div>
            <div class="flex items-center justify-between">
                <button id="action-button" 
                    class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full">
                    Проверить код
                </button>
                <span id="timer" class="text-sm text-gray-500 ml-2"></span>
            </div>
        `;

        // Get references to elements
        this.codeInput = this.container.querySelector('#verification-code');
        this.actionButton = this.container.querySelector('#action-button');
        this.timerSpan = this.container.querySelector('#timer');
        this.errorMessage = this.container.querySelector('#error-message');
    }

    setupEventListeners() {
        this.actionButton.addEventListener('click', () => {
            if (this.isInitialCode) {
                this.handleVerifyCode();
            } else {
                this.handleResendCode();
            }
        });

        this.codeInput.addEventListener('input', () => {
            if (!this.isInitialCode && this.codeInput.value.trim()) {
                this.resetToVerifyMode();
            }
        });
    }

    startTimer(seconds) {
        if (this.timer) {
            clearInterval(this.timer);
        }

        this.timeRemaining = seconds;
        this.updateTimerDisplay();

        this.timer = setInterval(() => {
            this.timeRemaining--;
            this.updateTimerDisplay();

            if (this.timeRemaining <= 0) {
                clearInterval(this.timer);
                if (this.isInitialCode) {
                    this.transformToResendMode();
                }
            }
        }, 1000);
    }

    updateTimerDisplay() {
        this.timerSpan.textContent = this.timeRemaining > 0 ? 
            `${this.timeRemaining}s` : '';
    }

    transformToResendMode() {
        this.isInitialCode = false;
        this.actionButton.textContent = 'Повторная отправка кода';
        this.actionButton.classList.remove('bg-blue-500', 'hover:bg-blue-700');
        this.actionButton.classList.add('bg-gray-500', 'hover:bg-gray-700');
        this.timerSpan.textContent = '';
    }

    resetToVerifyMode() {
        this.isInitialCode = true;
        this.actionButton.textContent = 'Проверить код';
        this.actionButton.classList.remove('bg-gray-500', 'hover:bg-gray-700');
        this.actionButton.classList.add('bg-blue-500', 'hover:bg-blue-700');
        this.startTimer(60);
    }

    showError(message) {
        this.errorMessage.textContent = message;
        this.errorMessage.classList.remove('hidden');
    }

    hideError() {
        this.errorMessage.classList.add('hidden');
    }

    async handleResendCode() {
        try {
            this.hideError();
            await authService.resendVerificationCode(this.email);
            this.resetToVerifyMode();
        } catch (error) {
            if (error.message.startsWith('COOLDOWN:')) {
                const remainingSeconds = parseInt(error.message.split(':')[1]);
                this.startTimer(remainingSeconds);
            } else {
                this.showError(error.message);
            }
        }
    }

    async handleVerifyCode() {
        try {
            this.hideError();
            const code = this.codeInput.value.trim();
            if (!code) {
                this.showError('Please enter verification code');
                return;
            }
            
            await authService.verifyEmail(this.email, code);
            if (this.onVerified) {
                this.onVerified(code);
            }
        } catch (error) {
            this.showError(error.message);
        }
    }

    mount(parentElement) {
        parentElement.appendChild(this.container);
        this.startTimer(30);
    }

    unmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.container.remove();
    }
}